import { Component, OnInit, Input } from '@angular/core';

import { ADPResourceService as ResourceService } from 'digital-core';
import { CustomIdBase } from 'digital-core';
import { QuestionInfo } from '../../models';

@Component({
  selector: 'warning-question',
  templateUrl: './warning-question.component.html',
  styleUrls: ['./warning-question.component.css']
})
export class WarningQuestionComponent extends CustomIdBase implements OnInit {
 
  @Input()
  question: QuestionInfo;
  
  constructor(public resourcesService: ResourceService) {
    super();
   }

  ngOnInit() {
    if(this.question){
      this.resourceName = this.question.Title;
      super.InitControl();
    }
    
  }

  getQuestionText(){
    return this.question? this.question.QuestionText:"";
  }
  

}
